module.exports = __webpack_public_path__ + "img/wholesaleBanner2.e324a09c.png";